import LogService from '@/services/log'
import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  error: ''
}

const getters = {
  getData: state => state.data,
  getTotalData: state => state.totalData,
  getError: state => state.error
}

// mutations
const mutations = {
  setData(state, { data, total }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    const tempData = state.data
    tempData.push(model)
    Vue.set(state, 'data', tempData)
    state.totalData = state.totalData + 1
  },
  setError(state, error) {
    state.error = error
  }
}

const actions = {
  findAll({ commit, state }, options) {
    return LogService.findAll(options).then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
